<template>
  <table class="c-table">
    <thead>
      <tr>
        <ThSort
          v-model="params.sort"
          name="keyword"
          orderby="asc"
          type="string"
        >
          キーワード
        </ThSort>
        <ThSort
          v-model="params.sort"
          name="yearMonth"
          orderby="desc"
          type="date"
          width="120"
        >
          調査月
        </ThSort>
        <ThSort
          v-model="params.sort"
          name="searchVolume"
          orderby="desc"
          type="number"
          width="30%"
        >
          月間検索数
        </ThSort>
      </tr>
    </thead>
    <tbody>
      <tr v-if="isLoading">
        <td colspan="3" class="l-p-0 c-text--center">
          <LoadingChara variant="inline">
            <template slot="title">
              データ取得中
            </template>
          </LoadingChara>
        </td>
      </tr>
      <template v-else>
        <ListItemKeyword
          v-for="(item, index) in sortedItems"
          :key="index"
          :item="item"
        />
      </template>
    </tbody>
  </table>
</template>

<script>
import ListItemKeyword from '@/components/searchVolume/ListItemKeyword';
import LoadingChara from '@/components/LoadingChara';
import ThSort from '@/components/ThSort';
import utils from '@/utils';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ListItemKeyword,
    LoadingChara,
    ThSort
  },
  data() {
    return {
      params: {
        sort: {
          name: 'searchVolume',
          orderby: 'desc',
          type: 'number'
        }
      }
    };
  },
  computed: {
    sortedItems() {
      const items = this.items.slice();
      return utils.sort(
        items,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    }
  }
};
</script>
